<script lang="ts">
  import { PlatformTypes, CenterImage } from '@centerhealth/fe/center-kit';

  // Author's name of the review
  export let author: string;

  // Author's image
  export let authorAvatar: string;

  // type of the platform (either apple-store or play-store), to show the icon for
  export let platformType: PlatformTypes;

  // The original post link on facebook, twitter..etc
  export let postLink: string;

  // Review's image, an image file path inside "public/assets"
  export let image: string;
</script>

<div
  class="card-footer relative border-solid border-t-2 pt-2 pb-2 pl-3 pr-3 box-border text-left text-base leading-8"
  class:p-3={image}
>
  {#if authorAvatar}
    <CenterImage>
      <img
        width="30"
        height="30"
        src={authorAvatar}
        alt={author}
        class="customer-avatar h-auto rounded-full float-left mr-2"
      />
    </CenterImage>
  {/if}
  {#if platformType && !authorAvatar}
    <div class="platform-icon inline-block overflow-hidden relative top-2 w-8 h-8 {platformType}">
      <CenterImage>
        <img
          width="30"
          height="30"
          src="/assets/images/platform-sprite.webp"
          alt={author}
          class="opacity-30"
        />
      </CenterImage>
    </div>
  {/if}
  {#if postLink}
    <a href={postLink} target="_blank" class="leading-9">{author}</a>
  {:else if author}
    <span class="leading-9">{author}</span>
  {/if}
</div>

<style>
  /** Card footer styling **/
  .card-footer {
    border-color: #eee;
  }
  .card-footer .platform-icon.play-store img {
    margin-top: -32px;
  }
  .customer-avatar {
    max-width: 34px;
  }
</style>
